import { OrderArticleTrackingDefectStation } from '../../../lib-shared/types/OrderArticleTrackingDefectStation';

export const OrderArticleTrackingDefectStationMap = new Map([
  [OrderArticleTrackingDefectStation.SORT, `Tri`],
  [OrderArticleTrackingDefectStation.WASHING, 'Lavage'],
  [OrderArticleTrackingDefectStation.DRYING, 'Séchage'],
  [OrderArticleTrackingDefectStation.IRONING_KANE, 'Repassage kané'],
  [OrderArticleTrackingDefectStation.IRONING_ELECTROLUX, 'Repassage Electrolux'],
  [OrderArticleTrackingDefectStation.IRONING_MACPI, 'Repassage Macpi'],
  [OrderArticleTrackingDefectStation.FOLDING, 'Pliage'],
  [OrderArticleTrackingDefectStation.PTL_IN, 'Entrée PTL'],
  [OrderArticleTrackingDefectStation.PTL_OUT, 'Sortie PTL'],
  [OrderArticleTrackingDefectStation.CONTROL, 'Contrôle qualité finale'],
  [OrderArticleTrackingDefectStation.PACKAGING, 'Emballage'],
]);
